<template>
  <form  action="" id="form" enctype="multipart/form-data">
  <div class="login-register">
    <div class="form-ipt">
      <h1 class="logo"><router-link to="/"><img :src="require('@/assets/images/logo.png')" alt=""></router-link></h1>
      <div class="form-title">密 码 登 录</div>
      <div class="form-cont">
        <el-input placeholder="请输入手机号" name="username" id="username" v-model="username" type="text" autocomplete="on"></el-input>
        <input type="hidden" v-for="(item,index) of inputs"  :name="item.name"  v-model="inputs[index].value" :key="index">

        <div class="form-item"><el-input type="password" placeholder="请输入密码" v-model="password"></el-input></div>
        <div class="left-right-two">
          <div class="left">
            <router-link class="blue" :to="codeLoginUrl">验证码登录</router-link>
          </div>
          <div class="right">
            <router-link to="/setPassword">忘记密码</router-link>
            <router-link :to="registerUrl">密码注册</router-link>
          </div>
        </div>
        <div class="login-btn">
          <el-button class="btn newbtn" size="medium" @click="login" :loading="loading">登 录</el-button>
        </div>
        <div class="back-index"><router-link to="/">返回首页</router-link></div>
        <div class="sanfang" v-if="!isMobile">
          <div class="tit">
            <span>使用第三方平台登录</span>
          </div>
          <div class="list">
            <a class="item qq"  @click="qqLoginClick" id="qqLoginBtn"></a>
            <a class="item wechat" href="https://open.weixin.qq.com/connect/qrconnect?appid=wx9889a16d40aac1b8&redirect_uri=http%3a%2f%2fwww.renrendonghua.com%2fauth%2fauthWeiXin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"></a>
            <a class="item weibo" href="https://api.weibo.com/oauth2/authorize?client_id=2471057307&response_type=code&redirect_uri=http://www.renrendonghua.com/auth/authWeiBo"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
  </form>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios';
  import vue from 'vue';
  import global_ from '@/api/global'
  vue.prototype.$axios = axios;
  import qs from 'qs';
  vue.prototype.qs = qs;
  import VueCookies from 'vue-cookies'
  vue.use(VueCookies);
export default {
  components: {

  },
  data () {
    return {
      isMobile:false,
      isWeiXin:false,
      registerUrl:"/register",
      codeLoginUrl:"/login",
      loading:false,
      username: '',
      password: '',
      fromUrl:"",
      inputs:[],
    }
  },
  created:function(){
  },
  mounted() {
    let _this=this;
    _this.checkIsMobile();
    _this.checkIsWeiXin();
    console.log("_this.$cookies",this.$cookies.get("formUrl"))
    if(window.location.href.indexOf("callback")!=-1){
      let url=window.location.href.substring(window.location.href.indexOf("callback"),window.location.href.length).replace("callback=","");
      this.fromUrl=decodeURIComponent(url);
      this.codeLoginUrl="/login?callback="+this.fromUrl
      this.registerUrl="/register?callback="+this.fromUrl
      console.log(this.fromUrl)
    }else{
      this.fromUrl='http://www.renrendonghua.com';
    }
    if(this.fromUrl!=""){
      let cs = this.fromUrl.split('?')[1];
      if(cs!=undefined){
        let arr= cs.split('&');
        if(arr.length>0){
          console.log(_this.inputs)
          arr.forEach(function (e) {

            console.log("aaaa",e)
            let nv= e.split("=")
            console.log("bbbbb",nv)
            // console.log("bbbbb",_this.fromUrl)
            _this.inputs.push({name:nv[0],value:nv[1]})
          })
          console.log(_this.inputs)
        }
        console.log("cs",arr)
      }
    }



  },
  methods: {
    qqLoginClick() {
      window.location.href="https://graph.qq.com/oauth2.0/authorize?client_id=101866307&response_type=token&scope=all&redirect_uri=http%3A%2F%2Fwww.renrendonghua.com%2Fauth%2FauthQQ";

      // 直接弹出授权页面，授权过后跳转到回调页面进行登录处理
      // eslint-disable-next-line no-undef
      // QC.Login.showPopup({
      //   appId:"101866307",
      //   redirectURI:"http://www.renrendonghua.com/auth/authQQ"  //登录成功后会自动跳往该地址
      // });
      // window.location.href="http://www.renrendonghua.com/auth/autoLoginQQ"
      // this.timer = setInterval(this.checkQQLogin, 1000);
    },
    checkIsMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      this.isMobile=flag;
    },
    checkIsWeiXin () {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf('micromessenger') > -1) {
        this.isWeiXin=true;
        return true; // 是微信端
      } else {
        this.isWeiXin=false;
        return false;
      }
    },
    login:function() {
      let _this=this;
      _this.loading=true;
      let postData = {
        'username':_this.username,
        'password':_this.password
      }
      let fast_login_url='http://cas.21teacher.com/restLoginCheck?time='+new Date().getMilliseconds();

      if(!this.username){
        _this.$message({
          message: '用户名不能为空',
          type: 'warning'
        });
        _this.loading=false;
        return false;
      }else if(!this.password){
        _this.$message({
          message: '密码不能为空',
          type: 'warning'
        });
        _this.loading=false;
        return false;
      }else{
        const reg = /^1[1|2|3|4|5|6|7|8|9][0-9]\d{8}$/
        if (!reg.test(this.username)) {
          _this.$message({
            message: '手机号码格式有误',
            type: 'warning'
          });
          _this.loading=false;
          return false;
        }
        _this.$axios.post(fast_login_url, qs.stringify(postData)).then(function(result){
          if(result.data.code==10){
            let checkUrl="/api/checkUserInfo?mobile="+_this.username+"&time="+ new Date().getMilliseconds();
            _this.$axios.get(checkUrl).then(function (re) {
              let d={"userId":result.data.userModel.id};
              let dataBoardUrl="/databoardapi/loginLog/add";
              _this.$axios.post(dataBoardUrl,qs.stringify(d)).then(function () {
                console.log("登录日志插入")
              });
              global_.setUserModel(result.data.userModel);
              let sso_sessionid =result.data.token;
              let user_id=result.data.userModel.id;
              let user_name=result.data.userModel.userName;
              let checkLogin='/api/checkLogin?sso_sessionid='+sso_sessionid+'&time='+ new Date().getMilliseconds();
              _this.$axios.get(checkLogin).then(function(result2){
                if(result2.data.isLogin&&result2.data.casFastUserModel!=null){
                  _this.$cookies.set("userId",user_id,0,"/",'.renrendonghua.com');
                  _this.$cookies.set("user_id",user_id,0,"/",global_.baseDomainURL+".com");
                  _this.$cookies.set("user_name",user_name,0,"/",global_.baseDomainURL+".com");
                  let updateLoginUrl="/rrbi/updateLoginUserInfo?time="+ new Date().getMilliseconds();
                  _this.$axios.get(updateLoginUrl).then(function (res) {
                    let message=res.data.message
                    if (message==4||message==5){
                      let noticUrl="/rrbi/notifications/saveRegisterNotify?userId="+result2.data.casFastUserModel.id+"&userName="+result2.data.casFastUserModel.name+"&objectType="+message
                      _this.$axios.get(noticUrl).then(function () {
                        if(_this.fromUrl!=""){
                          document.getElementById("form").setAttribute("action",_this.fromUrl);
                          document.getElementById("form").setAttribute("method","post");
                          document.getElementById("form").submit()
                        }else{
                          document.getElementById("form").setAttribute("action","http://www.renrendonghua.com");
                          document.getElementById("form").setAttribute("method","post");
                          document.getElementById("form").submit()

                        }
                      })
                    }else{
                      if(_this.fromUrl!=""){
                        document.getElementById("form").setAttribute("action",_this.fromUrl);
                        document.getElementById("form").setAttribute("method","post");
                        document.getElementById("form").submit()

                      }else{
                        document.getElementById("form").setAttribute("action","http://www.renrendonghua.com");
                        document.getElementById("form").setAttribute("method","post");
                        document.getElementById("form").submit()
                      }
                    }
                  })
                }else{
                  _this.$message({
                    message: '登录失败',
                    type: 'warning'
                  });
                }
              })

            })


          }else{
            _this.$message({
              message: '登录失败,用户名或密码错误',
              type: 'warning'
            });
            _this.loading=false;
          }
        })
      }
    }
  },
}
</script>

<style scoped lang="less">
@import "../../assets/less/login.less";
</style>
